import { configuration } from '@/config/InstanceConfiguration';

export class Category {
  label;
  path?: string;
  slug?: string;
  children?: Category[] | null;
  optionalAttributes?: any[];
  requiredAttributes?: any[];
  additionalAttributes?: any;
  parentSlugs?: [];
  isCurrent?: boolean;
  level?: number;

  public static of(data: any): Category {
    const c: Category = new Category();

    c.label = data.label;
    c.path = data.path;
    c.slug = data.slug;
    c.optionalAttributes = data?.optionalAttributes;
    c.requiredAttributes = data?.requiredAttributes;
    c.additionalAttributes = data?.additionalAttributes;
    c.parentSlugs = data?.parentSlugs;
    c.isCurrent = data?.isCurrent;
    c.children = (data.children || [])
        .map(child => Category.of(child));

    if (configuration.category.sortCategoriesAlphabetically && c.children) {
      c.children.sort((a, b) => a.label.localeCompare(b.label))
    }

    return c;
  }
}

export class RootCategory {
  label!:string;
  path!: string;
  slug!: string;
  countryCode!: string;
  alternates!: string[];
  xDefault!: boolean;

  public static of(data: any): RootCategory {
    const r: RootCategory = new RootCategory();

    r.label = data.label;
    r.path = data.path;
    r.slug = data.slug;
    r.countryCode = data.additionalAttributes.countryCode;
    r.alternates = data.additionalAttributes.alternates ? JSON.parse(data.additionalAttributes.alternates) : [];
    r.xDefault = data.additionalAttributes.xDefault === "true" || false;

    return r;
  }
}
